import { LoadingSkeleton } from "../../../../components/base/feedback/LoadingSkeleton"
import { classNames } from "../../../../lib/classNames"
import { TableCell, TableCellProps } from "../TableCell"

export interface TableBodyCellProps
  extends Omit<Extract<TableCellProps, { as: "td" }>, "as"> {
  isLoading?: boolean
}

export function TableBodyCell({
  isLoading,
  children,
  className,
  hideColumnBorders,
  ...otherProps
}: TableBodyCellProps) {
  return (
    <TableCell
      as="td"
      className={classNames("color-default", className)}
      hideColumnBorders={hideColumnBorders}
      {...otherProps}
    >
      {isLoading ? <Loading /> : children}
    </TableCell>
  )
}

function Loading() {
  return (
    <LoadingSkeleton className="h-3 w-2/3">
      <rect x="0" y="0" rx="6" ry="6" width="100%" height="100%" />
    </LoadingSkeleton>
  )
}
